import { HStack, VStack } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import { Image, ImageMap } from '@common/components/Image';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type ItemProps = {
  label: string;
  variant?: 'normal' | 'highlight' | 'footer';
  description?: string;
  icon?: keyof typeof IconMap;
  image?: keyof typeof ImageMap;
  value: string;
};

export const Item: React.FC<ItemProps> = ({ description, icon, variant = 'normal', image, label, value }) => {
  return (
    <HStack
      backgroundColor={variant === 'footer' ? 'rgba(0,0,0,0.05)' : 'transparent'}
      boxSizing="border-box"
      borderTopWidth="1px"
      borderTopStyle="solid"
      borderTopColor="blackAlpha.100"
      borderBottomRadius={variant === 'footer' ? '15px' : '0px'}
      display="flex"
      justifyContent={'space-between'}
      padding="20px 0"
      flexDirection="row"
      alignItems={'center'}
      width="full">
      <HStack paddingLeft="20px">
        {image && <Image image={image} width={['32px']} />}
        {icon && <Icon icon={icon} boxSize={['24px']} color="blue.500" />}
        <VStack alignItems={'flex-start'}>
          <TextBlock as="div" weight={variant === 'highlight' ? 'bold' : 'normal'}>
            {label}
          </TextBlock>
          {description && (
            <TextBlock color="grey" fontSize={'12px'}>
              {description}
            </TextBlock>
          )}
        </VStack>
      </HStack>
      <TextBlock as="div" paddingRight="20px" textAlign="right">
        {value}
      </TextBlock>
    </HStack>
  );
};
